export default "__VITE_ASSET__Df1y7KmY__"